// extracted by mini-css-extract-plugin
export default {"Expand__button":"styles_Expand__button__Kh13v","Expand__expanded":"styles_Expand__expanded__wd9Ti","Expand__expanded__noPadding":"styles_Expand__expanded__noPadding__JAh+t"};